var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("sell-categories"))),
                      ]),
                      _c(
                        "w-list",
                        _vm._l(
                          _vm.categories.getCategories(),
                          function (cat, i) {
                            return _c(
                              "w-list-item",
                              { key: i },
                              [
                                _c("w-list-item-text", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.Category", {
                                          num: i + 1,
                                        })
                                      )
                                    ),
                                  ]),
                                  _c("div", [_vm._v(_vm._s(cat.Name))]),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.edit"),
                                            expression: "$ct('common.edit')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditClicked(i + 1)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    { attrs: { value: _vm.toEditCategory != 0 } },
                    [
                      _vm.toEditCategory
                        ? _c("app-sell-category-edit-modal", {
                            attrs: { category: _vm.toEditCategory },
                            on: {
                              saved: function ($event) {
                                return _vm.saved()
                              },
                              close: function ($event) {
                                return _vm.closeModal()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }